// extracted by mini-css-extract-plugin
export default {"text":"TokenSvg_text__vGZkN"};